
export const propsComponent = ({ loading }) => {
	let FormGenerator: any = [];
	return {
		FormGenerator,
	};
};
